import styled from 'styled-components';

export const JackpotBetWidgetLogoDefaultBox = styled.div`
    width: 240px;
    height: 80px;

    background-size: 100%;
    background-position-y: 63%;
    margin-right: 8px;
    background-repeat: no-repeat, no-repeat;
    background-image: url(${props => props.theme.assets.images.jackpot_bet.jackpot_bet_logo_png.toString()});

    justify-self: flex-start;
    align-self: center;
    padding: 35px;
    max-width: 80%;
    position: relative;
    bottom: 40px;
`;